import React from "react";
import "../styles/Practices.css";

function Practices() {
  const practices = [
    {
      title: "Intellectual Property",
      image: "/practice-ip.png",
      subsections: [
        "Patents & Designs",
        "Trademarks",
        "Copyrights",
        "Assignment & Licensing"
      ]
    },
    {
      title: "Estate Planning",
      image: "/practice-estate.png",
      subsections: [
        "Will, Probate & Trust",
        "Property Nomination & Transfer",
        "Asset Distribution & Tax efficiency",
        "NRI Asset Planning & Protection"
      ]
    },
    {
      title: "Legal Advisory",
      image: "/practice-research.png",
      subsections: [
        "Marriage Counselling & Family Separation",
        "Property Dispute & Settlement",
        "Start-ups & Content Business Protection",
        "Research, Drafting & Co-counselling"
      ]
    }
  ];

  return (
    <section id="practices" className="practices-section">
      <div className="section-container">
        <h2>Our Practices</h2>
        <div className="practice-grid">
          {practices.map((practice, index) => (
            <div key={index} className="practice-card">
              <img
                src={practice.image || "/AboutUs.jpg"}
                alt={practice.title}
                className="practice-image"
                onError={(e) => { e.target.src = "/AboutUs.jpg"; }}
              />
              <h3>{practice.title}</h3>
              <ul>
                {practice.subsections.map((sub, i) => (
                  <li key={i}>{sub}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Practices;
